/* eslint-disable complexity */
import { wallet_errors } from '@common/constants'

export const mintErrorTreatment = (
    error: any,
): {
    code: string
    message: string
} => {
    if (error.message.includes(wallet_errors.NOT_MINED)) {
        return {
            code: 'NOT_MINTED',
            message:
                'This transaction was not mined within 50 blocks, please make sure your transaction was properly sent by reviewing Etherscan. Be aware that your transaction might still be sent.',
        }
    } else if (error.message.includes(wallet_errors.TRANSACTION_REJECTED)) {
        return {
            code: 'TRANSACTION_REJECTED',
            message: 'Transaction rejected',
        }
    } else if (error.message.includes(wallet_errors.NOT_ENOUGH_BALANCE)) {
        return {
            code: 'NOT_ENOUGH_BALANCE',
            message: 'Not enough balance',
        }
    } else if (error.message.includes(wallet_errors.SALES_FINISHED)) {
        return {
            code: 'SALES_FINISHED',
            message: 'This minting phase has completed.',
        }
    } else if (error.message.includes(wallet_errors.SALES_NOT_EXIST)) {
        return {
            code: 'SALES_NOT_EXIST',
            message: 'This minting phase does not exist.',
        }
    } else if (error.message.includes(wallet_errors.SALES_NOT_STARTED)) {
        return {
            code: 'SALES_NOT_STARTED',
            message: 'This minting phase has not started yet.',
        }
    } else if (error.message.includes(wallet_errors.SALES_SOLDOUT)) {
        return {
            code: 'SALES_SOLDOUT',
            message: 'This minting phase has sold out.',
        }
    } else if (error.message.includes(wallet_errors.COLLECTION_SOLDOUT)) {
        return {
            code: 'COLLECTION_SOLDOUT',
            message: 'Collection sold out, please select another category',
        }
    } else if (error.message.includes(wallet_errors.INVALID_SIGNATURE)) {
        return {
            code: 'INVALID_SIGNATURE',
            message: 'Your signature to this whitelist is invalid, ask for help.',
        }
    } else if (error.message.includes(wallet_errors.MAX_WALLET_LIMIT)) {
        return {
            code: 'MAX_WALLET_LIMIT',
            message: 'You have reached the maximum number of wallets allowed.',
        }
    } else {
        return {
            code: 'UNKNOWN_ERROR',
            message: 'Something went wrong ' + error.message,
        }
    }
}
